<template>
  <div
    :class="{ 'input--filled': filled, 'input_style_lock': locked }"
    class="input input_style"
  >
    <label>
      <div
        class="input__field input__field--ruri"
        id="address"
        v-if="locked"
      >
        {{value}}
      </div>
      <div
        v-else-if="hasSpecialDeliveryMethods"
        @click="focusDaDataInput"
        @focusout="unfocusDaDataInput"
      >
        <vue-dadata
          token="8570440c05eb64f618a5a42cbe6d78a7f068e2eb"
          :id="field"
          :ref="field"
          :query="localValue"
          :on-change="updateSpecialValue"
          classes="input__field input__field--ruri"
        ></vue-dadata>
      </div>

      <input
        :id="field"
        :ref="field"
        @blur="unfocus"
        @change="updateValue(localValue)"
        @focus="focus"
        class="input__field input__field--ruri"
        type="text"
        v-else
        v-model="localValue"
      />
    </label>
    <div class="input__label">
      <span class="input__label-content">{{ label }}</span>
      <span
        class="required"
        v-if="required"
      >
        <i><img
          :src="require('@/assets/img/facebook/inf_ico.svg')"
          alt="*"
        ></i>
      </span>
    </div>
  </div>
</template>

<script>
  import VueDadata from 'vue-dadata'
  import {SET_DELIVERY_TO_CITY, SET_DADATA_STREET} from '@/store/mutations.type'

  export default {

    name: 'TextInput',

    props: {
      value: {
        default: '',
        type: String
      },
      label: {
        default: '',
        type: String
      },
      field: {
        default: 'field',
        type: String
      },
      required: {
        default: false,
        type: Boolean
      },
      filled: {
        default: false,
        type: Boolean
      },
      locked: {
        default: false,
        type: Boolean
      },
      hasSpecialDeliveryMethods: {
        default: false,
        type: Boolean
      }
    },

    data() {
      return {
        localValue: this.value,
        isFocusedDaDataInput: false
      }
    },

    components: {
      'vue-dadata': VueDadata
    },

    methods: {
      unfocusDaDataInput() {
        this.isFocusedDaDataInput = !this.isFocusedDaDataInput
        this.$emit('focus', this.isFocusedDaDataInput)
      },
      focusDaDataInput(event) {
        // if (this.isFocusedDaDataInput && event.target === this.$refs.address.$refs.inputText) {
        //   return
        // }
        if (this.isFocusedDaDataInput && event.target === this.$refs.address) {
          return
        }
        // if (this.isFocusedDaDataInput && event.target === this.$refs.address) {
        //   return
        // }
        this.isFocusedDaDataInput = !this.isFocusedDaDataInput
        this.$emit('focus', this.isFocusedDaDataInput)
      },

      updateSpecialValue(suggestion) {
        this.updateValue(suggestion.value)

        if (suggestion.data.postal_code) {
          this.$emit('updatePostalCode', suggestion.data.postal_code)
        }
        if (suggestion.data.city) {
          this.$store.commit(SET_DELIVERY_TO_CITY, suggestion.data.city)
        }
        if (suggestion.data.street) {
          this.$store.commit(SET_DADATA_STREET, suggestion.data.street)
        }
      },
      focus() {
        this.$emit('focus')
      },
      unfocus() {
        this.$emit('unfocus')
      },
      updateValue(value) {
        this.$emit('update:value', value)
      }
    },

    watch: {
      value(value) {
        this.localValue = value
      }
    }
  }
</script>

<style scoped>
  .input__label {
    pointer-events: none;
  }

  .input_style {
    display: block;
    position: relative;
    height: 52px;
  }

  .input_style input {
    display: block;
    width: 100%;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    height: 34px;
    padding-left: 16px;
    padding-right: 16px;
    position: absolute;
    font-size: 15px;
    color: #1a1a1b;
    font-weight: 500;
    width: 100%;
    bottom: 2px;
    left: 0;
    background: none;
    border: none;
    border-bottom: 1px solid #f0f0f0;
    -webkit-transition: 0.4s;
    -moz-transition: 0.4s;
    -ms-transition: 0.4s;
    -o-transition: 0.4s;
    transition: 0.4s;
  }

  .input--filled .input__label-content {
    top: 5px;
    color: #1a1a1b;
    opacity: 0.4;
    font-size: 12px;
  }

  .input_style input:focus {
    border-color: #0084ff;
  }

  .input_style_lock {
    position: relative;
    height: auto;
  }

  .input_style_lock input {
    padding-right: 38px;
  }

  .input_style_lock textarea {
    padding-right: 38px;
    resize: none;
  }

  .input_style_lock div.input__field {
    width: 100%;
    box-sizing: border-box;
    font-size: 15px;
    color: #1a1a1b;
    font-weight: 500;
    background: none;
    padding: 24px 36px 7px 16px;
    border: none;
    border-bottom: 1px solid #f0f0f0;
    -webkit-transition: 0.4s;
    transition: 0.4s;
  }

  .input_style_lock:before {
    content: "";
    display: block;
    position: absolute;
    width: 16px;
    height: 16px;
    background: url("../../../assets/img/facebook/zamok.svg") no-repeat center center;
    right: 16px;
    top: 24px;
  }

  .error input {
    border-bottom: 1px solid red;
  }
</style>
